/* Wellness Vision — Español / English (native fallback when Weglot is unavailable). */
(function () {
  'use strict';

  var STORAGE = 'wv-lang';
  var textStore = typeof WeakMap !== 'undefined' ? new WeakMap() : null;

  var PHRASES = {
    'Saltar al contenido': 'Skip to content',
    'Catálogo': 'Catalog',
    'Saunas a medida': 'Custom saunas',
    'Crear mi proyecto': 'Start my project',
    'Nuestro enfoque': 'Our approach',
    'Tienda ↗': 'Shop ↗',
    'Tienda': 'Shop',
    'Carrito': 'Cart',
    'Hablemos de tu proyecto': "Let's talk about your project",
    'Idioma de la web': 'Site language',
    'Conectando idiomas…': '',
    'Traducción no disponible en este momento.': '',
    'Abrir menú': 'Open menu',
    'Cerrar menú': 'Close menu',
    'BIENESTAR PARA PROFESIONALES': 'WELLNESS FOR PROFESSIONALS',
    'DISEÑO · TECNOLOGÍA · EXPERIENCIA': 'DESIGN · TECHNOLOGY · EXPERIENCE',
    'UNA NUEVA VISIÓN DEL BIENESTAR': 'A NEW VISION OF WELLNESS',
    'Explorar el catálogo': 'Explore the catalog',
    'Descubrir nuestra visión': 'Discover our vision',
    'IMAGEN DEL CATÁLOGO GENERAL': 'GENERAL CATALOG IMAGE',
    'Diseñado para tu mundo': 'Designed for your world',
    'HOTELES Y ALOJAMIENTOS': 'HOTELS & STAYS',
    'GIMNASIOS Y CLUBES': 'GYMS & CLUBS',
    'CENTROS DE RECUPERACIÓN': 'RECOVERY CENTRES',
    '01 / LA VISIÓN': '01 / THE VISION',
    'familias de saunas': 'sauna families',
    'baños de inmersión': 'ice baths',
    'formatos de luz': 'light formats',
    '02 / EL EQUILIBRIO PERFECTO': '02 / THE PERFECT BALANCE',
    'Calor': 'Heat',
    'Saunas': 'Saunas',
    'Frío': 'Cold',
    'Baños de inmersión': 'Ice baths',
    'Luz': 'Light',
    'Fotobiomodulación': 'Photobiomodulation',
    'ELIGE. EXPLORA. IMAGINA.': 'CHOOSE. EXPLORE. IMAGINE.',
    'Cada categoría, en su espacio. Explora los modelos, compara hasta tres opciones y elige las cantidades para tu proyecto.':
      'Each category in its place. Explore models, compare up to three options and choose quantities for your project.',
    'Todas las categorías': 'All categories',
    'Luz roja': 'Red light',
    'Soluciones integrales': 'Integrated solutions',
    'Buscar en el catálogo': 'Search the catalog',
    'Buscar un modelo…': 'Search a model…',
    'FICHAS DE PRODUCTO · DATOS DE CATÁLOGO': 'PRODUCT SHEETS · CATALOG DATA',
    'Comparar': 'Compare',
    'En comparativa': 'In compare',
    'Añadir al proyecto +': 'Add to project +',
    'Añadido al proyecto ✓': 'Added to project ✓',
    'DISEÑO A MEDIDA': 'CUSTOM DESIGN',
    'INTEGRACIÓN POR PROYECTO': 'PROJECT INTEGRATION',
    'Configurar una sauna a medida': 'Configure a custom sauna',
    'Ver modelos y detalles ↗': 'View models & details ↗',
    'Espacios que se sienten.': 'Spaces you can feel.',
    'Volver arriba': 'Back to top',
    'Luz roja y fotobiomodulación': 'Red light & photobiomodulation',
    'Catálogos y fuentes': 'Catalogs & sources',
    'Cómo funciona tu solicitud': 'How your request works',
    'HECHO PARA EL BIENESTAR.': 'MADE FOR WELLBEING.',
    'Inicio': 'Home',
    'Filtros': 'Filters',
    'Categoría': 'Category',
    'Tipo de compra': 'Purchase type',
    'Todos': 'All',
    'Comprar online': 'Buy online',
    'Bajo presupuesto': 'Quote on request',
    'Precio': 'Price',
    'Desde': 'From',
    'Hasta': 'To',
    'Solo productos con compra online.': 'Online purchase products only.',
    'Limpiar filtros': 'Clear filters',
    'Ver resultados': 'View results',
    'Buscar productos': 'Search products',
    'Ordenar': 'Sort',
    'Destacados': 'Featured',
    'Precio: de menor a mayor': 'Price: low to high',
    'Precio: de mayor a menor': 'Price: high to low',
    'Nombre: A–Z': 'Name: A–Z',
    'COMPRA ONLINE': 'BUY ONLINE',
    'Online': 'Online',
    'Comprar': 'Buy',
    'Ver opciones': 'View options',
    'Agotado': 'Sold out',
    'productos': 'products',
    'producto': 'product',
    'No hay productos con estos filtros.': 'No products match these filters.',
    'Los modelos bajo presupuesto están en el catálogo de la portada.':
      'Quote-only models are on the homepage catalog.',
    'Abrir catálogo en la portada ↗': 'Open homepage catalog ↗',
    'Ver catálogo en la portada ↗': 'View homepage catalog ↗',
    'Tu carrito': 'Your cart',
    'Carrito vacío': 'Cart is empty',
    'Seguir comprando': 'Continue shopping',
    'Finalizar compra': 'Checkout',
    'Subtotal': 'Subtotal',
    'Impuestos y envío al pagar.': 'Taxes and shipping at checkout.',
    'Cerrar carrito': 'Close cart',
    'Abrir carrito': 'Open cart',
    'Buscar en la tienda': 'Search the shop',
    'Cerrar filtros': 'Close filters',
    'Cerrar': 'Close',
    'Cerrar resumen': 'Close summary',
    'Opción': 'Option',
    'Cantidad': 'Quantity',
    'Añadir al carrito': 'Add to cart',
    'Ver ficha de': 'View',
    'Ver la ficha técnica en el catálogo ↗': 'View technical sheet in catalog ↗',
    'Imagen': 'Image',
    'Quitar uno': 'Remove one',
    'Añadir uno': 'Add one',
    'Eliminar': 'Remove',
    'Impuestos y envío se calculan al finalizar la compra.': 'Taxes and shipping at checkout.',
    'TIENDA WELLNESS VISION': 'WELLNESS VISION SHOP',
    'Compra online': 'Buy online',
    'con precio publicado.': 'with a published price.',
    '¿Buscas sauna, baño de hielo o instalación integral?': 'Looking for a sauna, ice bath or full installation?',
    'Ver catálogo en la portada ↗': 'View homepage catalog ↗',
    'Negro': 'Black',
    'Blanco': 'White',
    'Rojo': 'Red',
    'Azul': 'Blue',
    'Verde': 'Green',
    'Gris': 'Grey',
    'Talla': 'Size',
    'Color': 'Colour',
    'Default Title': ''
  };

  var VARIANT_PHRASES = {
    Negro: 'Black',
    Blanco: 'White',
    Rojo: 'Red',
    Azul: 'Blue',
    Verde: 'Green',
    Gris: 'Grey',
    'Marrón': 'Brown',
    Multicolor: 'Multicolour',
    Beige: 'Beige',
    Color: 'Colour',
    'Color de la montura': 'Frame colour',
    'Default Title': ''
  };

  var PAGE_META = {
    home: {
      es: {
        title: 'Saunas a medida y bienestar profesional | Wellness Vision',
        description: 'Saunas a medida, baños de inmersión y luz roja para hoteles, gimnasios y centros de recuperación. Explora modelos y configura tu proyecto con Wellness Vision.'
      },
      en: {
        title: 'Custom saunas & professional wellness | Wellness Vision',
        description: 'Custom saunas, ice baths and red light for hotels, gyms and recovery centres. Explore models and configure your project with Wellness Vision.'
      }
    },
    tienda: {
      es: {
        title: 'Tienda | Wellness Vision',
        description: 'Compra online luz roja y accesorios Wellness Vision. Saunas, baños de inmersión y proyectos a medida en el catálogo de la portada.'
      },
      en: {
        title: 'Shop | Wellness Vision',
        description: 'Buy red light and Wellness Vision accessories online. Saunas, ice baths and custom projects are on the homepage catalog.'
      }
    }
  };

  function getLang() {
    var stored = '';
    try { stored = localStorage.getItem(STORAGE) || ''; } catch (e) { /* ignore */ }
    return stored === 'en' ? 'en' : 'es';
  }

  function setLang(code) {
    var lang = code === 'en' ? 'en' : 'es';
    try { localStorage.setItem(STORAGE, lang); } catch (e) { /* ignore */ }
    window.WV_LANG = lang;
    document.documentElement.lang = lang;
    document.documentElement.setAttribute('data-wv-lang', lang);
  }

  function rememberText(node) {
    if (!textStore) return node.nodeValue;
    if (!textStore.has(node)) textStore.set(node, node.nodeValue);
    return textStore.get(node);
  }

  function applyDataI18n(root, lang) {
    if (!root) return;
    root.querySelectorAll('[data-wv-i18n-en], [data-wv-i18n-en-html]').forEach(function (el) {
      // Re-applying the same language would replace markup that SplitText or page JS built on top.
      if (el.dataset.wvI18nLang === lang) return;
      el.dataset.wvI18nLang = lang;
      var enHtml = el.getAttribute('data-wv-i18n-en-html');
      if (enHtml != null) {
        if (!el.dataset.wvI18nEsHtml) el.dataset.wvI18nEsHtml = el.innerHTML;
        el.innerHTML = lang === 'en' ? enHtml : el.dataset.wvI18nEsHtml;
      } else {
        if (!el.dataset.wvI18nEs) el.dataset.wvI18nEs = el.textContent;
        if (lang === 'en') el.textContent = el.getAttribute('data-wv-i18n-en') || el.dataset.wvI18nEs;
        else el.textContent = el.dataset.wvI18nEs;
      }
    });
    ATTR_TAGS.forEach(function (pair) {
      var enAttr = 'data-wv-i18n-en-' + pair[0];
      var esAttr = 'data-wv-i18n-es-' + pair[0];
      root.querySelectorAll('[' + enAttr + ']').forEach(function (el) {
        if (!el.hasAttribute(esAttr)) el.setAttribute(esAttr, el.getAttribute(pair[1]) || '');
        el.setAttribute(pair[1], lang === 'en' ? el.getAttribute(enAttr) : el.getAttribute(esAttr));
      });
    });
  }

  var ATTR_TAGS = [
    ['placeholder', 'placeholder'],
    ['aria', 'aria-label'],
    ['alt', 'alt'],
    ['title', 'title']
  ];

  function applyNative(root, lang) {
    if (!root) return;
    lang = lang || getLang();
    applyDataI18n(root, lang);
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        if (!n.nodeValue || !n.nodeValue.trim()) return NodeFilter.FILTER_REJECT;
        var p = n.parentElement;
        if (!p || p.closest('script,style,noscript,textarea,[data-wv-i18n-skip],[data-wv-i18n-en],[data-wv-i18n-en-html]')) {
          return NodeFilter.FILTER_REJECT;
        }
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    var node;
    while ((node = walker.nextNode())) {
      var original = rememberText(node);
      if (lang === 'en') {
        var trimmed = original.trim();
        if (PHRASES[trimmed]) node.nodeValue = original.replace(trimmed, PHRASES[trimmed]);
      } else {
        node.nodeValue = original;
      }
    }
    // Only attributes with a PHRASES entry are switched here; anything else is either
    // tagged (handled in applyDataI18n) or owned by page JS that re-renders it per language.
    root.querySelectorAll('[placeholder]:not([data-wv-i18n-en-placeholder])').forEach(function (el) {
      if (el.closest('[data-wv-i18n-skip]')) return;
      if (!el.dataset.wvPhEs) el.dataset.wvPhEs = el.getAttribute('placeholder') || '';
      var ph = el.dataset.wvPhEs;
      if (!PHRASES[ph]) return;
      el.setAttribute('placeholder', lang === 'en' ? PHRASES[ph] : ph);
    });
    root.querySelectorAll('[aria-label]:not([data-wv-i18n-en-aria])').forEach(function (el) {
      if (el.closest('[data-wv-i18n-skip]')) return;
      if (!el.dataset.wvAriaEs) el.dataset.wvAriaEs = el.getAttribute('aria-label') || '';
      var a = el.dataset.wvAriaEs;
      if (!PHRASES[a]) return;
      el.setAttribute('aria-label', lang === 'en' ? PHRASES[a] : a);
    });
  }

  function weglotHasLang(code) {
    var wg = window.Weglot;
    if (!wg || !wg.initialized || typeof wg.getAvailableLanguages !== 'function') return false;
    try {
      return wg.getAvailableLanguages().indexOf(code) >= 0;
    } catch (e) { return false; }
  }

  function tryWeglotSwitch(code) {
    var wg = window.Weglot;
    if (!wg || !wg.initialized || typeof wg.switchTo !== 'function') return false;
    if (!weglotHasLang(code)) return false;
    try {
      wg.switchTo(code);
      return true;
    } catch (e) { /* ignore */ }
    return false;
  }

  function refreshWeglot() {
    var wg = window.Weglot;
    if (!wg || !wg.initialized) return;
    try {
      if (typeof wg.refresh === 'function') wg.refresh();
      else if (typeof wg.onPageChange === 'function') wg.onPageChange();
    } catch (e) { /* ignore */ }
  }

  function pageKind() {
    var root = document.getElementById('wv-home');
    if (!root) return null;
    if (root.dataset.wvTiendaPage === 'true') return 'tienda';
    if (root.dataset.wvHomePage === 'true') return 'home';
    return 'home';
  }

  function applyPageMeta(lang) {
    var kind = pageKind();
    if (!kind || !PAGE_META[kind]) return;
    var meta = PAGE_META[kind][lang === 'en' ? 'en' : 'es'];
    if (!meta) return;
    document.title = meta.title;
    var desc = document.querySelector('meta[name="description"]');
    if (desc) desc.setAttribute('content', meta.description);
  }

  function translateText(text, lang) {
    if (!text || lang !== 'en') return text;
    var t = String(text).trim();
    if (PHRASES[t]) return PHRASES[t];
    if (VARIANT_PHRASES[t]) return VARIANT_PHRASES[t];
    return text;
  }

  // Radiant layout chrome renders in the store locale (English), not in the WV language.
  function tagThemeChrome() {
    document.querySelectorAll('.skip-to-content-link:not([data-wv-i18n-en])').forEach(function (el) {
      el.setAttribute('data-wv-i18n-en', el.textContent.trim() || 'Skip to content');
      el.dataset.wvI18nEs = 'Saltar al contenido';
    });
    document.querySelectorAll('[aria-label="Close dialog"]:not([data-wv-i18n-en-aria])').forEach(function (el) {
      el.setAttribute('data-wv-i18n-en-aria', 'Close dialog');
      el.setAttribute('data-wv-i18n-es-aria', 'Cerrar diálogo');
    });
  }

  function applyLanguageToPage(lang) {
    var root = document.getElementById('wv-home');
    tryWeglotSwitch(lang);
    applyNative(root, lang);
    tagThemeChrome();
    // Tagged WV markup can also live outside #wv-home (builder dialog, sections moved in later).
    applyDataI18n(document.body, lang);
    var skip = document.querySelector('.skip[href="#contenido"], a.skip');
    if (skip && skip.closest('#wv-home') === null) applyNative(document.body, lang);
    applyPageMeta(lang);
  }

  function switchLang(code) {
    var lang = code === 'en' ? 'en' : 'es';
    window.dispatchEvent(new CustomEvent('wv-language-before-change', { detail: { lang: lang } }));
    setLang(lang);
    var root = document.getElementById('wv-home');
    var select = root && root.querySelector('[data-wv-language-select]');
    if (select) {
      select.value = lang;
      select.dispatchEvent(new Event('input', { bubbles: true }));
    }
    applyLanguageToPage(lang);
    window.dispatchEvent(new CustomEvent('wv-language-change', { detail: { lang: lang } }));
    requestAnimationFrame(function () {
      refreshWeglot();
    });
  }

  function optionLabel(select, value) {
    var opt = select.querySelector('option[value="' + value + '"]');
    return opt ? opt.textContent : value;
  }

  function enhanceCustomLangUi(select, onPick) {
    var control = select.closest('.wv-language-control');
    if (!control || control.dataset.wvLangUi === 'true') return;
    var trigger = control.querySelector('[data-wv-lang-trigger]');
    var menu = control.querySelector('[data-wv-lang-menu]');
    var currentEl = control.querySelector('[data-wv-lang-current]');
    if (!trigger || !menu || !currentEl) return;
    control.dataset.wvLangUi = 'true';

    function syncFromSelect() {
      currentEl.textContent = optionLabel(select, select.value);
      menu.innerHTML = '';
      Array.prototype.forEach.call(select.options, function (opt) {
        var li = document.createElement('li');
        li.setAttribute('role', 'presentation');
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'wv-lang-option';
        btn.setAttribute('role', 'option');
        btn.setAttribute('data-value', opt.value);
        btn.textContent = opt.textContent;
        btn.setAttribute('aria-selected', opt.value === select.value ? 'true' : 'false');
        btn.addEventListener('click', function () {
          closeMenu();
          if (opt.value === select.value) return;
          select.value = opt.value;
          onPick(opt.value);
        });
        li.appendChild(btn);
        menu.appendChild(li);
      });
      trigger.disabled = !!select.disabled;
    }

    function closeMenu() {
      menu.hidden = true;
      trigger.setAttribute('aria-expanded', 'false');
    }
    function openMenu() {
      if (trigger.disabled) return;
      menu.hidden = false;
      trigger.setAttribute('aria-expanded', 'true');
    }

    trigger.addEventListener('click', function (e) {
      e.stopPropagation();
      if (menu.hidden) openMenu();
      else closeMenu();
    });

    document.addEventListener('click', function (e) {
      if (!control.contains(e.target)) closeMenu();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeMenu();
    });

    trigger.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown' || e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        openMenu();
        var first = menu.querySelector('.wv-lang-option');
        if (first) first.focus();
      }
    });

    menu.addEventListener('keydown', function (e) {
      var opts = Array.prototype.slice.call(menu.querySelectorAll('.wv-lang-option'));
      var i = opts.indexOf(document.activeElement);
      if (e.key === 'Escape') {
        closeMenu();
        trigger.focus();
      } else if (e.key === 'ArrowDown' && i >= 0) {
        e.preventDefault();
        opts[Math.min(i + 1, opts.length - 1)].focus();
      } else if (e.key === 'ArrowUp' && i >= 0) {
        e.preventDefault();
        opts[Math.max(i - 1, 0)].focus();
      }
    });

    select.addEventListener('change', syncFromSelect);
    select.addEventListener('input', syncFromSelect);
    if (typeof MutationObserver !== 'undefined') {
      new MutationObserver(syncFromSelect).observe(select, {
        childList: true,
        attributes: true,
        attributeFilter: ['disabled']
      });
    }
    syncFromSelect();
  }

  function bindSelector(root) {
    if (!root || root.dataset.wvI18nBound === 'true') return;
    root.dataset.wvI18nBound = 'true';
    var select = root.querySelector('[data-wv-language-select]');
    var status = root.querySelector('[data-wv-language-status]');
    if (!select) return;

    select.innerHTML = '<option value="es">Español</option><option value="en">English</option>';
    select.disabled = false;
    select.removeAttribute('disabled');
    var preferred = getLang();
    setLang(preferred);
    select.value = preferred;
    if (status) status.textContent = '';

    select.addEventListener('change', function () {
      switchLang(select.value);
    });
    enhanceCustomLangUi(select, function (code) {
      switchLang(code);
    });

    function addWeglotExtras() {
      var wg = window.Weglot;
      if (!wg || !wg.initialized || typeof wg.getAvailableLanguages !== 'function') return;
      try {
        wg.getAvailableLanguages().filter(function (c) {
          return c !== 'es' && c !== 'en' && typeof c === 'string' && c.length < 12;
        }).forEach(function (code) {
          if (select.querySelector('option[value="' + code + '"]')) return;
          var opt = document.createElement('option');
          opt.value = code;
          opt.textContent = wg.getLanguageName(code) || code.toUpperCase();
          select.appendChild(opt);
        });
      } catch (e) { /* ignore */ }
    }

    var wg = window.Weglot;
    if (wg && typeof wg.on === 'function') {
      wg.on('initialized', function () {
        addWeglotExtras();
        select.value = getLang();
        select.dispatchEvent(new Event('input', { bubbles: true }));
        applyLanguageToPage(getLang());
      });
      wg.on('languageChanged', function () {
        var cur = wg.getCurrentLang();
        if (!cur || (cur !== 'en' && cur !== 'es')) return;
        setLang(cur);
        select.value = cur;
        select.dispatchEvent(new Event('input', { bubbles: true }));
        applyLanguageToPage(cur);
        window.dispatchEvent(new CustomEvent('wv-language-change', { detail: { lang: cur } }));
        requestAnimationFrame(refreshWeglot);
      });
      addWeglotExtras();
    }

    applyLanguageToPage(preferred);
  }

  window.WV_I18N = {
    getLang: getLang,
    setLang: setLang,
    switchLang: switchLang,
    applyNative: applyNative,
    applyLanguageToPage: applyLanguageToPage,
    bindSelector: bindSelector,
    refreshWeglot: refreshWeglot,
    translateText: translateText,
    phrase: function (es, en) { return getLang() === 'en' ? en : es; }
  };
  window.WV_LANG = getLang();
  document.documentElement.setAttribute('data-wv-lang', window.WV_LANG);
})();
